<template>
  <div>
      <div
            class="cstm-unique-tab cstm-unique-tab-bg-white flex mb-4"
        >
            <div style="width: calc(100% - 105px)" class="flex flex-wrap">
                <div
                    class="tab-name"
                    :class="{ activeTab: template }"
                    @click="tab('template')"
                >
                    Template
                </div>
                <div
                    class="tab-name"
                    :class="{ activeTab: notes }"
                    @click="tab('notes')"
                >
                    Notes
                </div>
            </div>
        </div>
        <div class="cstm-tab-holder">
      
        <div v-if="template">
          <Template />
        </div>

        <div v-if="notes">
          <NotesTab />
        </div>
    </div>

  </div>
</template>

<script>
import Template from './components/Template/index.vue'
import NotesTab from './components/Notes/index.vue'


export default {
  name: 'Notes',
  components: {
    Template,
    NotesTab
  },
  data () {
    return {
      template: true,
      notes: false
    }
  },
  methods: {
    tab (type) {
      if (type === 'template') {
        this.template = true
        this.notes = false
      } else if (type === 'notes') {
        this.template = false
        this.notes = true
      }
     
    }
   
  }
}
</script>